import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ReferentielService } from '../../../../core/services/referentiel.service';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { SafeMapsComponent } from '../../../../shared/components/maps/safe-maps.component';
import {
  BuildingIcon,
  LucideAngularModule,
  MailIcon,
  PhoneIcon,
  UserIcon,
  CircleIcon,
} from 'lucide-angular';
import { ThemeService } from '../../../../core/services/theme.service';

@Component({
  selector: 'app-structure-details',
  standalone: true,
  imports: [
    CommonModule,
    BannerComponent,
    SafeMapsComponent,
    LucideAngularModule,
  ],
  templateUrl: './structure-details.component.html',
  styleUrls: ['./structure-details.component.scss'],
})
export class StructureDetailsComponent implements OnInit {
  structure: any;
  loading = true;
  error: string | null = null;

  readonly UserIcon = UserIcon;
  readonly MailIcon = MailIcon;
  readonly PhoneIcon = PhoneIcon;
  readonly BuildingIcon = BuildingIcon;
  readonly CircleIcon = CircleIcon;

  bannnerLinks: { label: string; href?: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private referentielService: ReferentielService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'];
      const country = params['country'];

      this.bannnerLinks = [
        { label: 'Portail Public', href: `/${country}/home` },
        { label: 'Structures', href: `/${country}/structures` },
        { label: 'Détails', href: undefined },
      ];

      this.loadStructureDetails(id);
    });
  }

  private loadStructureDetails(id: string): void {
    this.loading = true;
    this.referentielService.getStructureDetails(id).subscribe({
      next: (structure) => {
        this.structure = structure;
        this.loading = false;
        // console.log('🔍 [STRUCTURE-DETAILS] Structure:', this.structure);
      },
      error: (error) => {
        console.error('Error loading structure details:', error);
        this.error = 'Error loading structure details';
        this.loading = false;
      },
    });
  }

  // Nom du produit selon le thème (FA'JMA ou Passeport Médical)
  getProductName(): string {
    return this.themeService.getProductName();
  }
}
